// ABOUTME: Tooltip component showing browser compatibility information
// ABOUTME: Displays warning message and list of supported browsers

import { memo } from "react"
import { useTranslation } from "react-i18next"
import { TooltipSection } from "./TooltipSection"
import { TooltipCheckList } from "./TooltipList"
import { TooltipHighlight } from "./TooltipHighlight"

interface BrowserSupportTooltipProps {
  message?: string
  messageKey?: string
  subtitleKey?: string
  browsers?: string[]
  className?: string
}

const DEFAULT_BROWSERS = ["Chrome", "Microsoft Edge", "Opera"]

export const BrowserSupportTooltip = memo(
  ({
    message,
    messageKey = "common.tooltipSyncLactate2",
    subtitleKey = "common.tooltipSyncLactate2subtitle",
    browsers = DEFAULT_BROWSERS,
    className = "",
  }: BrowserSupportTooltipProps) => {
    const { t } = useTranslation()

    const displayMessage = message ?? t(messageKey)
    const subtitle = t(subtitleKey)

    return (
      <div className={`w-[220px] ${className}`}>
        <TooltipHighlight type="warning">{displayMessage}</TooltipHighlight>

        <TooltipSection
          title={subtitle}
          className="mt-3"
        >
          <TooltipCheckList items={browsers} />
        </TooltipSection>
      </div>
    )
  },
)

BrowserSupportTooltip.displayName = "BrowserSupportTooltip"
